import MSlice from "../../helper/MSlice";

const userSlice = new MSlice({
  name: "user",
});

export const userActions = userSlice.getActions();

export default userSlice.getReducer();
